import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener } from '@angular/core';

@Component({
  selector: 'custom-shell-fabs',
  templateUrl: './custom-shell-fabs.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CustomShellFabsComponent {
  private static readonly SCROLL_SHOW = 420;

  visible = false;

  constructor(private cdr: ChangeDetectorRef) {}

  @HostListener('window:scroll')
  onScroll(): void {
    if (SSR) {
      return;
    }
    const next = window.scrollY > CustomShellFabsComponent.SCROLL_SHOW;
    if (next !== this.visible) {
      this.visible = next;
      this.cdr.markForCheck();
    }
  }

  scrollTop(): void {
    if (!SSR) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
}
